export const config = {
    "pic1_1": {
        author: ['Malina00000ooooo'],
        description : [
            "מזל סעדון, אלמנתו של דניאל (דני) סעדון ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%93%D7%A0%D7%99%D7%90%D7%9C%20%D7%A1%D7%A2%D7%93%D7%95%D7%9F/en_d29ab55370edcb09f961d6ffce203b00'],
        painting: './image12.png',
        smallPainting : './image12.png',
    },
    "pic2_1": {
        author: ['1111111Malina'],
        description : [
            "טל אליעז, בתו של ראובן (רובק'ה) אליעז ז\"ל",
            '"לעמוד האישי באתר "יזכור',
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A8%D7%90%D7%95%D7%91%D7%9F%20%D7%90%D7%9C%D7%99%D7%A2%D7%96/en_616442019fd84e6dd72ed356af6cd091'],
        painting: './image5.png',
        smallPainting : './image5.png',
    },
    "pic3_1": {
        author: ['1qazxcvMalina'],
        description : [
            "ענת רייס, בתו של חיים מילר מילוא ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%97%D7%99%D7%99%D7%9D%20%D7%9E%D7%99%D7%9C%D7%A8%20%D7%9E%D7%99%D7%9C%D7%95%D7%90/en_978c375d23b3760c3e13f4b3a474f693'],
        painting: './image15.png',
        smallPainting : './image15.png',
    },
    "pic4_1": {
        author: ['1hhhvvvMalina'],
        description : [
            "ברכה גולדשמיט, אלמנתו של אבנר גולדשמיט ז\"ל",
            '"לעמוד האישי באתר "יזכור',
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%90%D7%91%D7%A0%D7%A8%20%D7%92%D7%95%D7%9C%D7%93%D7%A9%D7%9E%D7%99%D7%98/en_e40f5da6b7cd13d11beb2d94b18476ac'],
        painting: './image4.png',
        smallPainting : './image4.png',
    },
    "pic5_1": {
        author: ['Malina'],
        description : [
            "גילה קלר-יניב, אחותו של יעקב (ינקו) קלר ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%99%D7%A0%D7%A7%D7%95%20%D7%A7%D7%9C%D7%A8/en_0b855cad0c1fa6937b89c45ab041e78b'],
        painting: './image13.png',
        smallPainting : './image13.png',
    },
    "pic6_1": {
        author: ['MalinAAAAa'],
        description : [
            "בתיה גזית, אלמנתו של עמיקם גזית ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A2%D7%9E%D7%99%D7%A7%D7%9D%20%D7%92%D7%96%D7%99%D7%AA/en_5e8dfd84589513f1f0456346f2af8720'],
        painting: './image20.png',
        smallPainting : './image20.png',
    },
    "pic7_1": {
        author: ['MalinaBBBB'],
        description : [
            "זהבה בלוך, אחותו של מרדכי בראון ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%A8%D7%93%D7%9B%D7%99%20%D7%91%D7%A8%D7%90%D7%95%D7%9F/en_eab8871a2e795078fdfc9cc6825499b5'],
        painting: './image14.png',
        smallPainting : './image14.png',
    },
    "pic8_1": {
        author: ['MaliBNBNBNna'],
        description : [
            "אורה אבישר, אחותו של יעקב ירון ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%99%D7%A2%D7%A7%D7%91%20%D7%99%D7%A8%D7%95%D7%9F/en_bdeecd68ff260c5ed15a4f2a21935091'],
        painting: './image2.png',
        smallPainting : './image2.png',
    },
    "pic9_1": {
        author: ['MMAMAalina'],
        description : [
            "חוה שבתאי, אלמנתו של אריה שבתאי ז\"ל ואחותו של שמחה ספיר ז\"ל",
            "\"לעמוד האישי של אריה ז\"ל באתר \"יזכור",
            "\"לעמוד האישי של שמחה ז\"ל באתר \"יזכור"
        ],
        pointerDesc: ["לעמוד האישי של אריה ז\"ל באתר \"יזכור\"" , "לעמוד האישי של שמחה ז\"ל באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%90%D7%A8%D7%99%D7%94%20%D7%A9%D7%91%D7%AA%D7%90%D7%99/en_5d7a84468cfe4c57ac50ab03dc240732',
        "https://www.izkor.gov.il/%D7%A9%D7%9E%D7%97%D7%94%20%D7%A1%D7%A4%D7%99%D7%A8/en_621766490bd65e15ec679b2e9bca7d74"],
        painting: './image9.png',
        smallPainting : './image9.png',
    },
    "pic12_1": {
        author: ['Malina222'],
        description : [
           "גילה אפשטיין, אחותו של דוד (דודי) כל טוב ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%93%D7%95%D7%93%20%D7%9B%D7%9C%20%D7%98%D7%95%D7%91/en_134c6b4f53896bdd7b14de93a2534ec1'],
        painting: './image1.png',
        smallPainting : './image1.png',
    },
    "pic13_1": {
        author: ['Malina333'],
        description : [
            "אביבה בריף, אחותו של יוסף (יוסי) סתוי שתיוי ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%99%D7%95%D7%A1%D7%A3%20%D7%A1%D7%AA%D7%95%D7%99%20%D7%A9%D7%AA%D7%99%D7%95%D7%99/en_ecdf34baa77f78a6a34c167314815642'],
        painting: './image16.png',
        smallPainting : './image16.png',
    },
    "pic14_1": {
        author: ['Malin12a'],
        description : [
            "רעיה גבזה רויף, אלמנתו של רמי רויף ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A8%D7%9E%D7%99%20%D7%A8%D7%95%D7%99%D7%A3/en_fe63e8a98ef54f48c483280bc36fbb92'],
        painting: './image22.png',
        smallPainting : './image22.png',
    },
    "pic15_1": {
        author: ['Malina432'],
        description : [
            "אורנה שאקי, אחותו של משה שאקי ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%A9%D7%94%20%D7%A9%D7%90%D7%A7%D7%99/en_2f13966cafe9220a2ca154f7dd46f71c'],
        painting: './image23.png',
        smallPainting : './image23.png',
    },
    "pic16_1": {
        author: ['Malin1321a'],
        description : [
            "סוניה גלס, אלמנתו של שמואל-אליעזר גלס ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A9%D7%9E%D7%95%D7%90%D7%9C-%D7%90%D7%9C%D7%99%D7%A2%D7%96%D7%A8%20%D7%92%D7%9C%D7%A1/en_1f334c1447aa49dc63f07c4afab07651'],
        painting: './image19.png',
        smallPainting : './image19.png',
    },
    "pic17_1": {
        author: ['Malina6547'],
        description : [
            "ירדן זהבי, בתו של חיים מילר מילוא ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%97%D7%99%D7%99%D7%9D%20%D7%9E%D7%99%D7%9C%D7%A8%20%D7%9E%D7%99%D7%9C%D7%95%D7%90/en_978c375d23b3760c3e13f4b3a474f693'],
        painting: './image18.png',
        smallPainting : './image18.png',
    },
    "pic18_1": {
        author: ['Malin2221111a'],
        description : [
            "יגאל דרויאן ז\"ל, אביו של רזיאל (רזי) דרויאן ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ["https://www.izkor.gov.il/%D7%A8%D7%96%D7%99%D7%90%D7%9C%20%D7%93%D7%A8%D7%95%D7%99%D7%90%D7%9F/en_5285ffaee7a71d182b2b37b79b236dfb"],
        painting: './image3.png',
        smallPainting : './image3.png',
    },
    "pic19_1": {
        author: ['Malinйцйцйa'],
        description : [
            "נורית יעקבס צדרבוים, אלמנתו של יוסף-צבי (בונדי) יעקבס ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%99%D7%95%D7%A1%D7%A3-%D7%A6%D7%91%D7%99%20%D7%99%D7%A2%D7%A7%D7%91%D7%A1/en_dd25f6abc34ca9621fbcc654dbbaa043'],
        painting: './image21.png',
        smallPainting : './image21.png',
    },
    "pic20_1": {
        author: ['Mali1357аааna'],
        description : [
            "פרידה כרמלי, אלמנתו של בן ציון (בנצי) כרמלי ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%91%D7%9F%20%D7%A6%D7%99%D7%95%D7%9F%20%D7%9B%D7%A8%D7%9E%D7%9C%D7%99/en_5ad1911efb918e064be348e9f973ec80'],
        painting: './image8.png',
        smallPainting : './image8.png',
    },
    "pic21_1": {
        author: ['Malinfhfhhha'],
        description : [
            "משה ביטון, אחיו של דוד (אליאס) ביטון ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%93%D7%95%D7%93%20%D7%91%D7%99%D7%98%D7%95%D7%9F/en_9cc443cffc3ebd7f4d82eb7b3780fafe'],
        painting: './image6.png',
        smallPainting : './image6.png',
    },
    "pic22_1": {
        author: ['Malin1qwtfa'],
        description : [
            "עירית לדרמן בשן, אלמנתו של צביקה בשן בורנשטיין ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A6%D7%91%D7%99%20%D7%91%D7%A9%D7%9F%20%D7%91%D7%95%D7%A8%D7%A0%D7%A9%D7%98%D7%99%D7%99%D7%9F/en_6438d3d09175d989df24c52d974e1cef'],
        painting: './image10.png',
        smallPainting : './image10.png',
    },
    "pic23_1": {
        author: ['Malina1111dddd'],
        description : [
            "חביבה מרקו, אחותו של מרדכי בראון ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%9E%D7%A8%D7%93%D7%9B%D7%99%20%D7%91%D7%A8%D7%90%D7%95%D7%9F/en_eab8871a2e795078fdfc9cc6825499b5'],
        painting: './image17.png',
        smallPainting : './image17.png',
    },
    "pic24_1": {
        author: ['Malinabbbbcccc'],
        description : [
            "כלב פולי פוליטי, אחיו של ראובן פוליטי ז\"ל",
            '"לעמוד האישי באתר "יזכור' ,
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%A8%D7%90%D7%95%D7%91%D7%9F%20%D7%A4%D7%95%D7%9C%D7%99%D7%98%D7%99/en_48fbabb982b4734fdbf214c10996400b'],
        painting: './image7.png',
        smallPainting : './image7.png',
    },
    "pic25_1": {
        author: ['Malina7777ffff'],
        description : [
            "טל (טלי) לב, אלמנתו של ארלוזור (זוריק) לב ז\"ל",
            '"לעמוד האישי באתר "יזכור'
        ],
        pointerDesc: ["לעמוד האישי באתר \"יזכור\""],
        link: ['https://www.izkor.gov.il/%D7%90%D7%A8%D7%9C%D7%95%D7%96%D7%95%D7%A8%20%D7%9C%D7%91/en_be417cf49f47197e9788968d0a5dc235'],
        painting: './image11.png',
        smallPainting : './image11.png',
    },
}
